export default __webpack_public_path__ + "static/media/chevronRight.9cc15890.svg";